import { computed, defineComponent, ref } from 'vue';
import { useStore } from 'vuex';
import { useSweetAlert } from '@/composables/sweetalert';
import { AnnouncementAction, AnnouncementGetter } from '@/store/announcement/announcement.module';
import { Announcement, AnnouncementAttachment } from '@/store/announcement/announcement.model';
import BaseModalComponent from '@/components/baseModal/BaseModal.vue';

export default defineComponent({
  name: 'AnnouncementDocumentComponent',
  components: {
    BaseModalComponent,
  },
  props: {
    announcementId: {
      type: Number,
    },
  },
  emits: [
    'upload'
  ],
  setup: (props, context) => {
    const store = useStore();
    const swal = useSweetAlert();
    const announcement = computed<Announcement | undefined>(() => store.getters[AnnouncementGetter.BY_ID](props.announcementId));
    const documents = computed<AnnouncementAttachment[]>(() => (announcement.value) ? announcement.value?.attachments.filter(m => m.attachmentType.id === 1) : []);
    const isLoading = computed(() => store.getters[AnnouncementGetter.STATUS] === 'init' || store.getters[AnnouncementGetter.STATUS] === 'loading');
    const announcementDocumentModal = ref<InstanceType<typeof BaseModalComponent>>();

    // show modal
    const show = () => {
      announcementDocumentModal.value?.show();
    };

    // hide modal
    const hide = () => {
      announcementDocumentModal.value?.hide();
    };

    // upload click
    const uploadClick = () => {
      hide();
      context.emit('upload');
    };

    // delete click
    const deleleClick = (id: number) => {
      swal.confirm('ลบข้อมูล!', 'คุณต้องการลบข้อมูลใช่หรือไม่?', 'ใช่ ลบเดี๋ยวนี้!', '#dc3545')
        .then((result) => {
          if (result.isConfirmed) {
            store.dispatch(AnnouncementAction.REMOVE_ATTACHMENT, {
              announcementId: props.announcementId,
              attachmentIds: [id],
            });
          }
        });
    };

    return {
      announcement,
      documents,
      announcementDocumentModal,
      isLoading,
      show,
      hide,
      uploadClick,
      deleleClick,
    };
  },
});
